var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33073 13.5352C2.32574 12.8625 1.66406 11.7168 1.66406 10.4167C1.66406 8.46369 3.15699 6.85941 5.06385 6.68281C5.45391 4.31011 7.51427 2.5 9.9974 2.5C12.4805 2.5 14.5409 4.31011 14.9309 6.68281C16.8378 6.85941 18.3307 8.46369 18.3307 10.4167C18.3307 11.7168 17.6691 12.8625 16.6641 13.5352M6.66406 13.3333L9.9974 10M9.9974 10L13.3307 13.3333M9.9974 10V17.5",
    stroke: "#408BBA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/uploadCloud.d9172abb0843acbcef5ace6633644a2e.svg";
export { ForwardRef as ReactComponent };